import { render, staticRenderFns } from "./UlFileRegistersvg.vue?vue&type=template&id=4c947cee&scoped=true&"
import script from "./UlFileRegistersvg.vue?vue&type=script&lang=ts&"
export * from "./UlFileRegistersvg.vue?vue&type=script&lang=ts&"
import style0 from "./UlFileRegistersvg.vue?vue&type=style&index=0&id=4c947cee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c947cee",
  null
  
)

export default component.exports